import { render, staticRenderFns } from "./avatar.vue?vue&type=template&id=2fb81a28&scoped=true&"
import script from "./avatar.vue?vue&type=script&lang=js&"
export * from "./avatar.vue?vue&type=script&lang=js&"
import style0 from "./avatar.less?vue&type=style&index=0&id=2fb81a28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb81a28",
  null
  
)

export default component.exports